import party from "party-js";

export const useParty = (ref: React.RefObject<HTMLDivElement | null>) => {
  const triggerParty = () => {
    if (ref.current) {
      party.confetti(ref.current, {
        count: party.variation.range(40, 80),
        size: 1,
      });
    }
  };

  return { triggerParty };
};
